import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts'
import { formatKES } from '@/lib/utils'

export interface CollectionsChartPoint {
  label: string
  totalCollected: number
  count: number
}

function CollectionsTooltip({
  active,
  payload,
}: {
  active?: boolean
  payload?: { payload: CollectionsChartPoint }[]
}) {
  if (!active || !payload?.length) return null
  const point = payload[0]!.payload
  return (
    <div className="rounded border border-border-2 bg-card px-3 py-2 shadow-modal">
      <p className="font-sans text-xs font-medium text-ink">{point.label}</p>
      <p className="font-sans text-sm font-medium text-status-paid-text">
        {formatKES(point.totalCollected)}
      </p>
      <p className="font-sans text-[11px] text-muted-foreground">
        {point.count} payment{point.count === 1 ? '' : 's'}
      </p>
    </div>
  )
}

export function CollectionsChart({
  data,
  isLoading,
}: {
  data: CollectionsChartPoint[]
  isLoading: boolean
}) {
  if (isLoading) return <p className="font-sans text-sm text-muted-foreground">Loading…</p>
  if (data.length === 0) {
    return (
      <p className="rounded border border-border-2 px-4 py-6 text-center font-sans text-sm text-muted-foreground">
        No payments in this range.
      </p>
    )
  }

  return (
    <div className="h-64 rounded border border-border-2 bg-card p-4">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data} margin={{ top: 8, right: 8, left: 0, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="hsl(var(--border-2))" />
          <XAxis
            dataKey="label"
            tick={{ fontSize: 11, fill: 'hsl(var(--muted-foreground))' }}
            axisLine={{ stroke: 'hsl(var(--border-2))' }}
            tickLine={false}
          />
          <YAxis
            tick={{ fontSize: 11, fill: 'hsl(var(--muted-foreground))' }}
            axisLine={false}
            tickLine={false}
            tickFormatter={(value: number) => formatKES(value)}
            width={80}
          />
          <Tooltip content={<CollectionsTooltip />} cursor={{ fill: 'hsl(var(--cream-2))' }} />
          <Bar dataKey="totalCollected" fill="hsl(var(--primary))" radius={[3, 3, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  )
}
